import { BoldText } from "components";
import React from "react";

import { useLanguageQuestion } from "screens/question/hooks";
import { Title } from "screens/question/themeB/section";

import { Container, ListContainer, ListItem, ListText } from "./styled";

export const TileQuestion = ({ question }) => {
  const { selectLanguage, selectedOptions } = useLanguageQuestion(question);
  return (
    <Container>
      <Title>{question.text}</Title>
      <Title>{question.text_urdu}</Title>
      <ListContainer>
        {question.options.map(option => {
          const isSelected = selectedOptions[option.virtual_id];
          return (
            <ListItem
              key={option.id}
              onPress={() => selectLanguage(option)}
              $isSelected={isSelected}
            >
              <ListText $isSelected={isSelected}>
                <BoldText>{option.text}</BoldText>
              </ListText>
            </ListItem>
          );
        })}
      </ListContainer>
    </Container>
  );
};
